import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { IDotProgressIndicatorStep } from '../../interfaces/dot-progress-indicator-step-interface';
import { PinAndSignatureProgress } from './pin-and-signature-progress.enum';
import { DotProgressIndicatorComponent } from '../dot-progress-indicator/dot-progress-indicator.component';
import { SignaturePadComponent } from '../signature-pad/signature-pad.component';
import { ButtonIconPositions } from '../../interfaces/button-icon-position.enum';
import { PinService } from '../../services/pin.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ISignerWitnessPinSignatureCollectedEvent } from '../../interfaces/singer-witness-pin-signature-collected.event';
import { getBase64FromDataUrl } from '../../helpers/helpers';

@UntilDestroy()
@Component({
  selector: 'app-enter-pin-with-signature-stepper-dialog',
  templateUrl: './enter-pin-with-signature-stepper-dialog.component.html',
  styleUrls: ['./enter-pin-with-signature-stepper-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EnterPinWithSignatureStepperDialogComponent implements OnInit{
  @Output() cancel: EventEmitter<void> = new EventEmitter();
  @Output() save: EventEmitter<ISignerWitnessPinSignatureCollectedEvent> = new EventEmitter();

  showPinDialog: boolean;
  showWitnessPinDialog: boolean;
  singerSignature: string;
  signerPin: string;
  witnessSignature: string;
  witnessPin: string;

  signerSignaturePadReadOnly: boolean;
  witnessSignaturePadReadOnly: boolean;

  header = 'Signature collection';
  subHeader = 'Digitally sign your DEA Compliance Report';

  PinAndSignatureProgress = PinAndSignatureProgress;
  ButtonIconPositions = ButtonIconPositions;

  signerPinDialogId = 'signer';
  witnessPinDialogId = 'witness';

  steps: IDotProgressIndicatorStep[] = [
    {
      id: PinAndSignatureProgress.Signature,
      isActive: true,
      canActivatePredicate: () => true
    },
    {
      id: PinAndSignatureProgress.WitnessSignature,
      canActivatePredicate: () => !!this.signerPin && !!this.singerSignature
    },
  ];

  currentStep: IDotProgressIndicatorStep = this.steps[0];

  @ViewChild('stepper') 
  public stepper: DotProgressIndicatorComponent;

  @ViewChild('signaturePad') 
  public signaturePad: SignaturePadComponent;

  @ViewChild('witnessSignaturePad') 
  public witnessSignaturePad: SignaturePadComponent;
  /**
   *
   */
  constructor(private pinService: PinService, private cdr: ChangeDetectorRef) { 
  }

  ngOnInit(): void {
   this.pinService.validatePin$
   .pipe(untilDestroyed(this))
   .subscribe(res => {
     if (res?.dialogId === this.signerPinDialogId && res?.success) {
      this.signerPin = res.pin.toString();
      if (this.stepper.canActivateNext()) {
        this.stepper.next();
      }
      this.pinService.closeDialog();
     } else if (res?.dialogId === this.witnessPinDialogId && res?.success) {
      this.witnessPin = res.pin.toString();
      this.finish();
      this.pinService.closeDialog();
     }
     this.cdr.markForCheck();
   })
  }

  finish(): void {
    if (this.singerSignature && this.signerPin && this.witnessSignature && this.witnessPin) {
      this.save.next({
        base64SignerSignature: getBase64FromDataUrl(this.singerSignature),
        signerPin: this.signerPin,
        base64WitnessSignature: getBase64FromDataUrl(this.witnessSignature),
        witnessPin: this.witnessPin
      });
    }
  }

  stepSelected(step: IDotProgressIndicatorStep): void {
    this.currentStep = step;
    switch (step.id) {
      case PinAndSignatureProgress.WitnessSignature:
        this.header = 'Witness signature collection';
        this.subHeader = 'Digitally sign your DEA Compliance Report';
        break;
      default:
        this.header = 'Signature collection';
        this.subHeader = 'Digitally sign your DEA Compliance Report';
        break;
    }
  }


  async drawComplete(event: MouseEvent | Touch) {
    this.singerSignature = this.signaturePad.toDataURL();
  }

  async witnessDrawComplete(event: MouseEvent | Touch) {
    this.witnessSignature = this.witnessSignaturePad.toDataURL();
  }

  signatureCleared(): void {
    this.singerSignature = null;
  }

  witnessSignatureCleared(): void {
    this.witnessSignature = null;
  }

  openSignerPin(): void {
    if (this.singerSignature) {
      this.signerSignaturePadReadOnly = true;
      this.pinService.openPinDialog(this.signerPinDialogId);
    }
   }

   openWitnessPin(): void {
    if (this.singerSignature && this.signerPin && this.witnessSignature) {
      this.witnessSignaturePadReadOnly = true;
      this.pinService.openWitnessDialog(this.witnessPinDialogId);
    }
   }

}
